export default __webpack_public_path__ + "static/media/Avatar-15.892ffb6a.png";